export default __webpack_public_path__ + "static/media/1434.1a41fed1.png";